import RerunStrategyValues from 'eflex/constants/rerun-strategy-values';

export default [
  { value: RerunStrategyValues.alwaysRerun, label: 'plant.task.rerunStrategies.always' },
  { value: RerunStrategyValues.rerunRejects, label: 'plant.task.rerunStrategies.rejects' },
  { value: RerunStrategyValues.neverRerun, label: 'plant.task.rerunStrategies.never' },
];
